import { useEffect } from 'react'
import { gql, useQuery } from '@apollo/client'
import { amplitudeEvent } from 'lib/amplitude'

const GET_PAYMENT_ACCOUNT_SETUP_REDIRECT_URL = gql`
  query paymentAccountLinkSetup(
    $accountName: String
    $returnUrl: String!
    $accountId: String
  ) {
    paymentAccountLinkSetup(
      accountName: $accountName
      returnUrl: $returnUrl
      accountId: $accountId
    ) {
      accountLink
    }
  }
`

const StripeAccountSetupRedirect = ({ accountName, accountId }) => {
  const { data } = useQuery(GET_PAYMENT_ACCOUNT_SETUP_REDIRECT_URL, {
    variables: {
      accountName,
      returnUrl: window.location.origin + window.location.pathname,
      accountId,
    },
  })

  useEffect(() => {
    const path = window.location.pathname
    const source = path?.includes('junior-league')
      ? 'JRL'
      : path.includes('family-golf')
        ? 'FG'
        : 'Coach'
    if (accountId) {
      amplitudeEvent('refreshed-payment-account-onboarding', {
        source,
        url: window.location.href,
        path: path,
      })
    }
  }, [accountId])

  useEffect(() => {
    const redirectUrl = data?.paymentAccountLinkSetup?.accountLink

    if (redirectUrl) {
      window.location = redirectUrl
    }
  }, [data])
  return null
}

export default StripeAccountSetupRedirect
